export default __webpack_public_path__ + "static/media/img19.df8fe43a.svg";